import { cartierDebug, trace } from 'Utils/Debug'

const encryptData = async (formData, encryptKey) => {
	const newFormData = formData
	const formDataFields = formData.map((x) => x.name)
	const passwordFields = [
		'RegistrationViewModel.Password',
		'PasswordRecoveryViewModel.NewPassword',
		'UpdatePasswordViewModel.OldPassword',
		'UpdatePasswordViewModel.NewPassword',
	]
	const extraPasswordFields = [
		'RegistrationViewModel.PasswordConf',
		'PasswordRecoveryViewModel.NewPasswordConfirm',
		'UpdatePasswordViewModel.NewPasswordConf',
	]
	const formDataPassword = passwordFields.filter((x) => formDataFields.indexOf(x) !== -1)

	const clearPasswordFields = () => {
		;[...passwordFields, ...extraPasswordFields].forEach((passwordField) => {
			const fieldIndex = formDataFields.indexOf(passwordField)
			if (fieldIndex !== -1) newFormData[fieldIndex].value = ''
		})
	}

	if (!encryptKey) {
		if (yTos.environment === 'prod') {
			const err = Error('Unable to encrypt data: no public key found.')
			await trace({
				level: 'Error',
				tags: ['SSO'],
				message: err.message,
				stackTrace: err.stack,
			})
			cartierDebug('error', err)
			clearPasswordFields()
			return newFormData
		}

		cartierDebug('info', 'INFO: no public key found, SSO data encrypt is disabled.')
		return newFormData
	}

	try {
		const { RsaEncryptJS } = await import('@ynap-ofs/sso-rsaencryptjs')
		const rsa = new RsaEncryptJS()
		await rsa.importKey(encryptKey)
		await Promise.all(
			formDataPassword.map(async (field) => {
				const fieldIndex = formDataFields.indexOf(field)
				const fieldConfIndex = formDataFields.indexOf(`${field}Conf`)
				const fieldConfirmIndex = formDataFields.indexOf(`${field}Confirm`)
				const clearPassword = formData[fieldIndex].value
				const encryptedPassword = await rsa.encrypt(clearPassword)

				if (clearPassword === encryptedPassword) {
					throw Error(
						'Unable to encrypt data: clear and encrypted passwords are equal (likely a CryptoAPI issue).'
					)
				}

				newFormData[fieldIndex].value = encryptedPassword
				if (fieldConfIndex !== -1) {
					newFormData[fieldConfIndex].value = encryptedPassword
				}
				if (fieldConfirmIndex !== -1) {
					newFormData[fieldConfirmIndex].value = encryptedPassword
				}
			})
		)
		return newFormData
	} catch (error) {
		await trace({
			level: 'Error',
			tags: ['SSO'],
			message: error.message,
			stackTrace: error.stack,
		})
		cartierDebug('error', error)
		clearPasswordFields()
		return newFormData
	}
}

export default encryptData
